import { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [
    { path: "/", label: "Home" },
    { href: "/Catloge", label: "Products" },
    // { href: "/products", label: "Products" },
    { href: "/services", label: "Services" },
    // { href: "#brands", label: "Brands" },
    // { href: "/Catloge", label: "Catloge" },
    { href: "/products", label: "Our Offerings" },
    { path: "/about", label: "About" },
    { href: "/contact", label: "Contact" }
  ];
  return (
    <header className="bg-white/95 backdrop-blur-md border-b border-gray-200/80 fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="/images/orginal.png"
              alt="Nexora Logo"
              className="h-10 w-10"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#002946]">NEXORA</span>
              <span className="text-xs text-gray-600 -mt-1">Machinery</span>
            </div>
          </Link>
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item, index) => (
              item.path ? (
                <Link
                  key={index}
                  to={item.path}
                  className="text-gray-700 hover:text-[#002946] font-medium text-sm transition-colors duration-200 relative py-2"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d9ff] transition-all duration-300 hover:w-full"></span>
                </Link>
              ) : (
                <a
                  key={index}
                  href={item.href}
                  className="text-gray-700 hover:text-[#002946] font-medium text-sm transition-colors duration-200 relative py-2"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#00d9ff] transition-all duration-300 hover:w-full"></span>
                </a>
              )
            ))}
          </nav>
          <div className="hidden lg:flex items-center space-x-4">
            <div className="text-right">
              <div className="text-sm font-semibold text-[#002946]">+91 91506 20187</div>
              <div className="text-xs text-gray-500">saleshead@nexoramachinery.com</div>
            </div>
            <button className="bg-[#002946] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#004e7c] transition-colors duration-200">
              Login
            </button>
          </div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors duration-200"
          >
            <div className="w-6 h-6 flex flex-col justify-center space-y-1">
              <span className={`block h-0.5 w-6 bg-[#002946] transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-[#002946] transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-[#002946] transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </div>
          </button>
        </div>
        <div className={`lg:hidden border-t border-gray-200 transition-all duration-300 overflow-hidden ${isOpen ? 'max-h-97 py-4' : 'max-h-0'}`}>
          <nav className="flex flex-col items-center justify-center space-y-4">
            {navItems.map((item, index) => (
              item.path ? (
                <Link
                  key={index}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className="text-gray-700 hover:text-[#002946] font-medium py-2 transition-colors duration-200"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={index}
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                  className="text-gray-700 hover:text-[#002946] font-medium py-2 transition-colors duration-200"
                >
                  {item.label}
                </a>
              )
            ))}
          </nav>
          <div className="pt-4 border-t border-gray-200 mt-4">
            <div className="text-center mb-4">
              <div className="text-sm font-semibold text-[#002946]">+91 91506 20187</div>
              <div className="text-xs text-gray-500 mt-1">info@nexoramachinery.com</div>
            </div>
            <button 
              onClick={() => setIsOpen(false)}
              className="w-full bg-[#002946] text-white py-3 rounded-lg font-semibold hover:bg-[#004e7c] transition-colors duration-200"
            >
              Get Quote
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;